import React from "react";

import "../styles/components/Struktura.css";

function StrukturCard({ history, title, sub, id, redir }) {
  console.log(title);
  return (
    <div
      onClick={() => {
        history.push(`/${redir ? redir : "struktura"}/` + id);
      }}
      className="strukture-item-wrapper"
    >
      <div className="structure structureColor">
        <div className="structName">{title}</div>
      </div>
    </div>
  );
}

export default StrukturCard;
